<template>
  <div
    id="supplierDetail"
    v-loading="loading"
  >
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            社區廠商內容
          </div>
        </div>
        <div class="right">
          <div>
            <el-button
              round
              @click="$router.push({name:'supplierEdit', query: {...$route.query}})"
            >
              編輯
            </el-button>
          </div>
        </div>
      </div>
      <div class="blockWrap">
        <el-form
          ref="newsData"
          class="list"
          :model="newsData"
          status-icon
          :show-message="false"
        >
          <el-form-item label="名稱">
            <span>{{ newsData.SupplierName }}</span>
          </el-form-item>
          <el-form-item label="簡述">
            <span>{{ newsData.SubTitle }}</span>
          </el-form-item>
          <el-form-item label="類別">
            <span>{{ newsData.TypeName }}</span>
          </el-form-item>
          <el-form-item label="統一編號">
            <span>{{ newsData.TaxIdNumber }}</span>
          </el-form-item>
          <el-form-item label="聯絡人">
            <span>{{ newsData.ContactName }}</span>
          </el-form-item>
          <el-form-item label="電話">
            <span>{{ newsData.SupplierTel }}</span>
          </el-form-item>
          <el-form-item label="手機">
            <span>{{ newsData.SupplierPhone }}</span>
          </el-form-item>
          <el-form-item label="地址">
            <span>{{ newsData.City }}{{ newsData.Area }}{{ newsData.Address }}</span>
          </el-form-item>
          <el-form-item label="廠商介紹">
            <span>{{ newsData.Content }}</span>
          </el-form-item>
          <el-form-item label="附加檔案">
            <div class="file-wrap">
              <div
                v-for="(file, file_ind) in newsData.Files"
                :key="file_ind"
                class="file"
                @click="downloadFile(file.Url)"
              >
                <div class="fileName">
                  {{ `檔案${file_ind + 1}` }}
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      newsData: {},
      loading: true
    }
  },
  mounted () {
    this.GetSupplierData()
  },
  methods: {
    // 取得廠商詳情
    GetSupplierData () {
      if (!this.$route.query.supplierId) return
      apiAsset.Supplier.GetSupplier({
        SupplierId: this.$route.query.supplierId
      }).then(res => {
        console.log(res)
        this.newsData = res.data
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    downloadFile (fileUrl) {
      axios(fileUrl, {
        method: 'GET',
        headers: { KingnetAuth: `Cookies ${this.$getCookie('comLoginToken').replace('token=', '')}` },
        responseType: 'blob'
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const fileName = fileUrl.split('/')[fileUrl.split('/').length - 1]
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
<style lang="sass" scoped>
#supplierDetail
  padding: 50px 0
  ::v-deep .el-dialog
    +basicDialog
    p
      line-height: 25px
  .main
    min-width: 1140px
    max-width: 1140px
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        color: $mainFontColor
        text-align: left
  ::v-deep .el-form.list
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    .el-form-item
      display: flex
      align-items: flex-start
      width: 100%
      box-sizing: border-box
      +basicForm
      &__label
        font-weight: bold
        flex-basis: 105px
        vertical-align: top
        text-align: right
      &__content
        flex: 1
        // max-width: 400px
        .el-select,.el-date-editor
          width: 100%
        .file-wrap
          display: flex
          flex-wrap: wrap
          .file
            width: 150px
            height: 150px
            border: 1px solid #ccc
            color: #666
            border-radius: 4px
            cursor: pointer
            margin: 10px
            position: relative
            overflow: hidden
            background-position: center
            background-size: cover
            &:hover
              color: #333
              border: 1px solid #aaa
              box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
              transition: .4s
              .optionBtn-wrap
                bottom: 0
            i
              font-size: 60px
            .fileName
              font-size: 17px
              font-weight: 700
              width: 100%
              height: 100%
              line-height: 150px
              text-align: center
</style>
